import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import {
	getAttentionDashboard,
	updateAttentionDashboard,
} from '../../thunks/attention_dashboard_thunks';
import { withUserType } from '../withUserType';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { savedFilterViewsRestCrudThunksForSupplier } from '../../thunks/saved_filter_views_thunks';
import { SUPPLIER_BASE_VIEW_OPTIONS } from '../../utils/DataConstants';
import {
	useWorkOrdersViewTabs,
	WORK_ORDERS_OVERVIEW_TABS_COLLECTION,
} from '../work_orders_overview_page/useViewTabs';
import OverviewShell from '../overview_shell/OverviewShell';

const SUPPLIER_OVERVIEW_PATH = '/supplier/workOrders/overview';
const style = require('./SupplierWorkOrdersOverviewPage.less');

const SupplierWorkOrdersOverviewPage = ({
	childRoutes,
	defaultView,
	getWorkOrderDefaultView,
	fetchWorkOrderViews,
	workOrderViews,
	workOrderViewsLoading,
	attentionDashboards,
	saveAttentionDashboard,
}) => {
	const { loading, redirectTarget, tabs, handleTabChange, checkTabActive, tabsRightActions } =
		useWorkOrdersViewTabs({
			basePath: SUPPLIER_OVERVIEW_PATH,
			baseViewOptions: SUPPLIER_BASE_VIEW_OPTIONS,
			defaultView,
			workOrderViews,
			workOrderViewsLoading,
			attentionDashboards,
			saveAttentionDashboard,
			fetchWorkOrderViews,
			getWorkOrderDefaultView,
		});

	if (loading) return null;
	return (
		<>
			<Route path={SUPPLIER_OVERVIEW_PATH} exact render={() => <Redirect to={redirectTarget} />} />
			<OverviewShell
				title="Work Orders"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="workOrdersPage"
				tabsRightActions={tabsRightActions}
				tabsClassName="items-center justify-start"
				creationRoutes={['new', 'newWorkOrder']}
			/>
		</>
	);
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	getWorkOrderDefaultView: () => getAttentionDashboard(dispatch, ownProps.userType),
	fetchWorkOrderViews: (
		params,
		targetCollectionName = WORK_ORDERS_OVERVIEW_TABS_COLLECTION,
		pagination = { current: 1, pageSize: 100 },
		sorting?,
		filters?
	) =>
		dispatch(
			savedFilterViewsRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters
			)
		),
	saveAttentionDashboard: (entity) => updateAttentionDashboard(dispatch, ownProps.userType, entity),
});

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,
	defaultView: state.session.defaultView,
	workOrderViews: getRecordsForTargetCollection(
		state.saved_filter_views,
		WORK_ORDERS_OVERVIEW_TABS_COLLECTION
	),
	workOrderViewsLoading: nullSafeGet(
		`${WORK_ORDERS_OVERVIEW_TABS_COLLECTION}.fetching`,
		state.saved_filter_views
	),
	attentionDashboards: state.attention_dashboards.detail,
});

export default withRouter(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(SupplierWorkOrdersOverviewPage))
);
